import { i18n as legacyI18n } from '@legacy/js/plugin/vue-i18n.js';

/**
 * The subset of a vue-i18n `global` instance these components use. Both hosts supply a
 * real `createI18n({...}).global`; the shape is named here so an override can be
 * type-checked without importing vue-i18n's generics.
 */
export interface I18nLike {
    t: (key: string, ...args: any[]) => string
}

let override: I18nLike | null = null;

/**
 * Point the shared components at a different vue-i18n instance.
 *
 * The monolith needs no call: `@legacy/js/plugin/vue-i18n.js` is its instance, built
 * from the `window.kgr.i18n._messages` catalogue. The Vue apps in `apps/` run their own
 * (`apps/shared/i18n.ts`, catalogue fetched from `/apis/translation/{appId}/messages`)
 * and register it here before mounting.
 *
 * Both catalogues are keyed on the German source text — the project-wide convention —
 * so the very same `i18n.t('Bringen')` call resolves in either host.
 *
 * A module-level registry rather than provide/inject because `useI18n()` is called
 * during pinia store setup, where Vue's injection context is not reliably present.
 */
export function setI18n(instance: I18nLike): void {
    override = instance;
}

export function useI18n() {
    return {
        i18n: override ?? legacyI18n,
    };
}
